import axios from './http';
import { CodeDto, UpsertCodeDto } from 'ts-types/api.types';
import { CancelTokenSource } from 'axios';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/code`;

export const getAllCodesByCodeGroupId = (codeGroupId: number, source: CancelTokenSource): Promise<Array<CodeDto>> => {
  return axios
      .get(`${apiUri}/code-group/${codeGroupId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const findCodeById = (id: number, source: CancelTokenSource): Promise<CodeDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const searchCode = (query: String, source: CancelTokenSource): Promise<Array<CodeDto>> => {
  return axios
      .get(`${apiUri}`, {params: {query}, cancelToken: source.token})
      .then(response => response.data);
};

export const addCode = (upsertCodeDto: Partial<UpsertCodeDto>, source: CancelTokenSource): Promise<CodeDto> => {
  return axios
      .post(apiUri, upsertCodeDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editCode = (id: number, upsertCodeDto: Partial<UpsertCodeDto>, source: CancelTokenSource): Promise<CodeDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertCodeDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteCode = (id: number, source: CancelTokenSource): Promise<CodeDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};
